// Lazy load jsPDF to reduce initial bundle size
export const exportPdf = async (title, searchDate, tableData) => {
  // Dynamic import - jsPDF (~150KB) only loads when export is triggered
  const { default: jsPDF } = await import("jspdf");
  await import("jspdf-autotable");
  const { getDateFormate } = await import("./helper");
  const [fontRupee, ImageTwo, ImageThree] = await Promise.all([
    fetch("/fonts/DejaVuSans-Bold.ttf").then((r) => r.arrayBuffer()).then((buf) => {
      const bytes = new Uint8Array(buf);
      let binary = "";
      for (let i = 0; i < bytes.length; i++) binary += String.fromCharCode(bytes[i]);
      return btoa(binary);
    }),
    fetch("/images/pdf/ImageTwo.b64").then((r) => r.text()),
    fetch("/images/pdf/ImageThree.b64").then((r) => r.text()),
  ]);
  
  // var width = doc.internal.pageSize.getWidth();
  // var height = doc.internal.pageSize.getHeight();
  // console.log(doc.getFontList());
  // ₹
  // herderColor = rgb(25,66,100);
  // textColor = rgb(210,227,234);
  // subHeaderColor = rgb(91,127,155);
  // subHeaderColorlt = rgb(138,168,188);

  // sercond //

  // header = 240,130,52

  // sercond //

  const unit = "pt";
  const size = "A4"; // Use A1, A2, A3 or A4
  const orientation = "l"; // portrait or landscape
  // const title = props.reportPage.label;
  //  const format = [canvas.width + 60, canvas.height + 160]
  // const marginLeft = 40;
  const doc = new jsPDF(orientation, unit, size);

  doc.addFileToVFS("DejaVuSans-Bold-bold.ttf", fontRupee);
  doc.addFont("DejaVuSans-Bold-bold.ttf", "DejaVuSans-Bold", "normal");
  doc.setFont("DejaVuSans-Bold");
  // doc.setFontSize(20);
  // doc.text("vijay = ₹", 20, 20);
  // log available fonts
  // console.log("avaiable fonts :",doc.getFontList());
  doc.setFontSize(23);
  doc.setFont("helvetica");
  const totalWidth = doc.internal.pageSize.getWidth();
  // const totalHeight = doc.internal.pageSize.getHeight();
  const titleHead = title.toUpperCase();
  const xOffset =
    doc.internal.pageSize.width / 2 -
    (doc.getStringUnitWidth(titleHead) * doc.internal.getFontSize()) / 2;
  // const lineWidth = (input) => doc.getStringUnitWidth(input) * 25 + xOffset;
  //  rgb(14,18,29)
  // main header part //
  doc.addImage(ImageTwo, "JPEG", 0, 0, totalWidth, 85);
  doc.addImage(ImageThree, "JPEG", 0, 80, totalWidth, 55);
  doc.setFontSize(25);
  doc.setFont("Helvetica", "bold");
  doc.setTextColor(255, 255, 255);
  doc.text(titleHead, xOffset, 55);
  doc.setLineWidth(1.5);
  doc.setTextColor(255, 255, 255);
  // doc.line(xOffset, 55, lineWidth(titleHead), 55);
  // title background box //
  // title background box //
  doc.setFontSize(18);
  doc.setTextColor(250, 242, 92);
  doc.text(title.toUpperCase(), 20, 115);
  doc.setFontSize(13);
  doc.setFont("helvetica", "bold");
  doc.setTextColor(210, 227, 234);
  doc.text(
    "Period  : " +
    getDateFormate(searchDate.fromDate) +
    " to  " +
    getDateFormate(searchDate.toDate),
    doc.internal.pageSize.width - 230,
    112
  );

  // main header part //
  // second = 109,142,77
  // 186,209,179
  // subtitle part //

  const subTitleOne = (input, setHeight) => {
    doc.setFontSize(13);
    const title = input.toUpperCase();
    const titleWidth = doc.getStringUnitWidth(title) * 13;
    const boxStart = 40;
    const boxEnd = titleWidth + 30;
    const titleStart = 40 + 15;
    doc.setDrawColor(232, 14, 134);
    doc.setFillColor(232, 14, 134);
    doc.rect(boxStart, setHeight, boxEnd, 20, "F");
    // doc.addImage(ImageOne, "JPEG", boxStart, setHeight, boxEnd, 20);
    doc.setTextColor(254, 245, 255);
    // const heightRange = doc.internal.pageSize.getHeight() - setHeight;
    // let condition = heightRange >= 0 && heightRange <= 70;
    // if (condition) {
    //    doc.addPage(size, orientation);
    //     return doc.text(title, titleStart, condition ? 40 : setHeight + 15);
    // }
    //   condition = false;
    //    return !condition && doc.text(title, titleStart, setHeight + 15);

    return doc.text(title, titleStart, setHeight + 15);
  };
  // subTitleOne(subtitle);
  // subtitle part //

  // table part //
  doc.setFont("DejaVuSans-Bold");
  const bodyContent = (height, headers, body, styles) => {
    //  subTitleOne(subtitle, setHeight);
    //   const heightRange = doc.internal.pageSize.getHeight() - setHeight;
    //  const  condition = heightRange >= 0 && heightRange <= 70
    //    if(heightRange >= 0 && heightRange <= 70 ){
    //   doc.addPage(size, orientation);
    // }

    const content = {
      // startY: condition ? 60 : height + 20,
      startY: height + 20,
      head: headers,
      body: body,
      setFont: "DejaVuSans-Bold",
      theme: "striped",
      tableWidth: "auto",
      pageBreak: "auto",
      tableLineColor: [210, 227, 234],
      tableLineWidth: 0.75,
      addFont: "DejaVuSans-Bold",
      styles: {
        font: "DejaVuSans-Bold",
      },
      headStyles: {
        0: {
          halign: "start",
          valign: "middle",
        },
        halign: "center",
        valign: "middle",
        fontSize: 11,
        height: 25,
        fillColor: [141, 53, 150],
        textColor: [210, 227, 234],
        tableLineColor: [210, 227, 234],
        tableLineWidth: 0.75,
      },
      bodyStyles: {
        halign: "center",
        valign: "middle",
        fontSize: 10,
        paddingTop: 5,
        paddingBottom: 5,
      },
      columnStyles: styles,
    };
    // if(heightRange >= 0 && heightRange <= 70 ){
    //   doc.addPage(size, orientation);
    // }
    return doc.autoTable(content);
  };
  // doc.autoTable(content);
  // doc.previousAutoTable.finalY
  // const finalY = doc.lastAutoTable.finalY
  // tableData.map((table, ind) => doc.autoTable(bodyContent(ind == 0 ? 185 : doc.lastAutoTable.finalY + 10, table.headers, table.body, table.subtitle,  ind == 0 ? 160 : doc.lastAutoTable.finalY + 10)));
  // var tableEnd = 0;
  // subTitleOne(table.subtitle, ind == 0 ? 160 : doc.autoTableEndPosY() + 20);
  // tableEnd = doc.previousAutoTable.finalY + 10;

  tableData.map((table, ind) => {
    table.subtitle &&
      subTitleOne(
        table.subtitle,
        ind == 0 ? 160 : doc.lastAutoTable.finalY + 30
      );
    bodyContent(
      ind == 0 ? 170 : doc.lastAutoTable.finalY + 40,
      table.headers,
      table.body,
      table.styles
    );
  });

  // table part //

  doc.save(`${title}.pdf`);
};

// Lazy load jsPDF to reduce initial bundle size
export const exportPDFC = async (title, headers, data, styles, customHeader, size = "A4") => {
  const { default: jsPDF } = await import("jspdf");
  await import("jspdf-autotable");
  const fontRupee = await fetch("/fonts/DejaVuSans-Bold.ttf")
    .then((r) => r.arrayBuffer())
    .then((buf) => {
      const bytes = new Uint8Array(buf);
      let binary = "";
      for (let i = 0; i < bytes.length; i++) binary += String.fromCharCode(bytes[i]);
      return btoa(binary);
    });

  // ─────────────────────────────────────────────────────────────────────────────
  // Site primary palette  (hsl(221 83% 53%) → #2463EB family)
  // ─────────────────────────────────────────────────────────────────────────────
  const PRIMARY       = [36,  99,  235];  // --primary  hsl(221 83% 53%)
  const PRIMARY_DARK  = [22,  63,  165];  // darker shade for header bg
  const PRIMARY_LIGHT = [239, 244, 255];  // very light blue tint for alt rows
  const DARK_BG       = [8,   15,  40];   // site dark bg  hsl(222 84% 4.9%)
  const WHITE         = [255, 255, 255];
  const TEXT_DARK     = [15,  23,  42];   // close to hsl(0 0% 3.9%)
  const TEXT_MUTED    = [100, 116, 139];  // muted-foreground hsl(0 0% 45%)
  const BORDER_CLR    = [226, 232, 240];  // site border hsl(0 0% 89.8%)

  // ─────────────────────────────────────────────────────────────────────────────
  // Layout
  // ─────────────────────────────────────────────────────────────────────────────
  const unit        = "pt";
  const orientation = "landscape";
  const HEADER_H    = 72;    // total header block height
  const ACCENT_BAR  = 4;     // thick colored bar below header
  const FOOTER_H    = 30;
  const TABLE_TOP   = HEADER_H + ACCENT_BAR + 14;
  const SIDE_PAD    = 18;

  const tableSize = headers[0].length;
  const doc       = new jsPDF(orientation, unit, size);
  const pageW     = doc.internal.pageSize.getWidth();
  const pageH     = doc.internal.pageSize.getHeight();

  doc.addFileToVFS("DejaVuSans-Bold-bold.ttf", fontRupee);
  doc.addFont("DejaVuSans-Bold-bold.ttf", "DejaVuSans-Bold", "normal");

  // ─────────────────────────────────────────────────────────────────────────────
  // drawHeader  – full-width dark navy bar + logo left + title right area
  // ─────────────────────────────────────────────────────────────────────────────
  const drawHeader = () => {
    // ① Dark navy background bar
    doc.setFillColor(...DARK_BG);
    doc.rect(0, 0, pageW, HEADER_H, "F");

    // ② Left primary-color side accent strip
    doc.setFillColor(...PRIMARY);
    doc.rect(0, 0, ACCENT_BAR, HEADER_H, "F");

    // ③ Report title — left-aligned, vertically centered
    const titleHead = title.toUpperCase();
    doc.setFont("DejaVuSans-Bold", "normal");
    doc.setFontSize(17);
    doc.setTextColor(...WHITE);
    doc.text(titleHead, SIDE_PAD + ACCENT_BAR + 6, HEADER_H / 2 + 2);

    // ④ "Generated on" tag — right-aligned
    const now = new Date();
    const dateLabel = `Generated: ${now.toLocaleDateString("en-GB", {
      day: "2-digit", month: "short", year: "numeric",
    })}  ${now.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" })}`;
    doc.setFontSize(7.5);
    doc.setTextColor(...TEXT_MUTED);
    const dateW = doc.getStringUnitWidth(dateLabel) * 7.5;
    doc.text(dateLabel, pageW - SIDE_PAD - dateW, HEADER_H / 2 + 2);

    // ⑤ Primary-blue accent bar beneath header
    doc.setFillColor(...PRIMARY);
    doc.rect(0, HEADER_H, pageW, ACCENT_BAR, "F");
  };

  // ─────────────────────────────────────────────────────────────────────────────
  // drawFooter
  // ─────────────────────────────────────────────────────────────────────────────
  const drawFooter = (pageNum, totalPages) => {
    const y = pageH - FOOTER_H;

    // Light border line
    doc.setDrawColor(...BORDER_CLR);
    doc.setLineWidth(0.75);
    doc.line(SIDE_PAD, y, pageW - SIDE_PAD, y);

    // Primary dot accent
    doc.setFillColor(...PRIMARY);
    doc.circle(SIDE_PAD, y + FOOTER_H / 2, 2.5, "F");

    // Report title (left)
    doc.setFont("helvetica", "bold");
    doc.setFontSize(7.5);
    doc.setTextColor(...TEXT_MUTED);
    doc.text(title, SIDE_PAD + 8, y + FOOTER_H / 2 + 2.5);

    // Page indicator pill (right)
    const pageStr  = `Page ${pageNum} / ${totalPages}`;
    const psW      = doc.getStringUnitWidth(pageStr) * 7.5;
    const pillX    = pageW - SIDE_PAD - psW - 14;
    const pillY    = y + 7;
    const pillH    = 14;
    const pillW    = psW + 14;

    // Pill background
    doc.setFillColor(...PRIMARY_LIGHT);
    doc.roundedRect(pillX, pillY, pillW, pillH, 3, 3, "F");

    // Pill border
    doc.setDrawColor(...PRIMARY);
    doc.setLineWidth(0.5);
    doc.roundedRect(pillX, pillY, pillW, pillH, 3, 3, "S");

    // Pill text
    doc.setFont("helvetica", "bold");
    doc.setTextColor(...PRIMARY_DARK);
    doc.text(pageStr, pillX + 7, pillY + pillH / 2 + 2.5);
  };

  // ─────────────────────────────────────────────────────────────────────────────
  // Font sizes
  // ─────────────────────────────────────────────────────────────────────────────
  const getBodyFontSize = () => {
    if (tableSize <= 3) return 9;
    if (tableSize === 4) return 8.5;
    if (tableSize === 5) return 8;
    if (tableSize === 6) return 7.5;
    if (tableSize === 7) return 7;
    if (tableSize === 8) return 6.5;
    if (tableSize === 9) return 6;
    return 5.5;
  };
  const headFontSize = customHeader
    ? getBodyFontSize() + customHeader
    : getBodyFontSize() + 1.5;

  const defaultColumnStyles = { halign: "center", valign: "middle" };

  // ─────────────────────────────────────────────────────────────────────────────
  // Render
  // ─────────────────────────────────────────────────────────────────────────────
  drawHeader();

  doc.autoTable({
    startY: TABLE_TOP,
    head: headers,
    body: data,
    theme: "plain",
    tableWidth: "auto",
    pageBreak: "auto",
    margin: { top: 14, left: SIDE_PAD, right: SIDE_PAD, bottom: FOOTER_H + 10 },
    styles: {
      font: "helvetica",
      fontStyle: "normal",
      fontSize: getBodyFontSize(),
      cellPadding: { top: 6, right: 7, bottom: 6, left: 7 },
      overflow: "linebreak",
      textColor: TEXT_DARK,
      lineColor: BORDER_CLR,
      lineWidth: 0.35,
    },
    headStyles: {
      fillColor: PRIMARY,
      textColor: WHITE,
      fontStyle: "bold",
      fontSize: headFontSize,
      halign: "center",
      valign: "middle",
      lineColor: PRIMARY_DARK,
      lineWidth: 0,
      cellPadding: { top: 8, right: 7, bottom: 8, left: 7 },
    },
    bodyStyles: {
      halign: "center",
      valign: "middle",
      fillColor: WHITE,
    },
    alternateRowStyles: {
      fillColor: PRIMARY_LIGHT,
    },
    columnStyles: styles || defaultColumnStyles,
    // Switch to DejaVuSans-Bold only for cells that contain special Unicode
    // symbols (e.g. ₹ £ € ¥) that helvetica cannot render
    didParseCell: (hookData) => {
      if (hookData.section === "body") {
        const cellText = String(hookData.cell.raw ?? "");
        const hasUnicode = /[\u0100-\uFFFF]/.test(cellText);
        if (hasUnicode) {
          hookData.cell.styles.font = "DejaVuSans-Bold";
          hookData.cell.styles.fontStyle = "normal";
        }
      }
    },
    didDrawPage: (hookData) => {
      drawFooter(hookData.pageNumber, hookData.doc.getNumberOfPages());
    },
  });

  // Ensure footer on all pages (corrects page count after table draw)
  const totalPages = doc.getNumberOfPages();
  for (let i = 1; i <= totalPages; i++) {
    doc.setPage(i);
    drawFooter(i, totalPages);
  }

  doc.save(`${title}.pdf`);
};
